export const getCurrentUser = state => state.user.currentUser;
export const getOneSignalId = state => state.user.oneSignalId;
export const getUserPreferences = state => state.user.preferences;
export const getEnableBetaFeatures = state =>
  !!state.user?.preferences?.approvals?.flags?.enableBetaFeatures;
